import { initialState } from "./state";

export const setAccountPlanFeatures = (state, payload) => {
  state.accountPlanFeatures = payload;
};

export const reset = (state) => {
  const s = initialState();

  Object.keys(s).forEach((key) => {
    state[key] = s[key];
  });
};
